



















import arrayMove from 'array-move'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class BlockMovingControls extends Vue {
  @Prop() readonly value!: Array<any>

  @Prop() readonly position!: number

  @Prop({ type: Boolean }) readonly vertical!: boolean

  public movePosition(destinationPosition: number): void {
    this.$emit('input', arrayMove(this.value, this.position, destinationPosition))
  }
}
